import { render, staticRenderFns } from "./BaseButtonRemove.vue?vue&type=template&id=3921c254&scoped=true&"
import script from "./BaseButtonRemove.vue?vue&type=script&lang=js&"
export * from "./BaseButtonRemove.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonRemove.vue?vue&type=style&index=0&id=3921c254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3921c254",
  null
  
)

export default component.exports